/**
 * Type guard to check if a switch statement covers the whole enumeration
 * Taken from https://stackoverflow.com/questions/39419170/how-do-i-check-that-a-switch-block-is-exhaustive-in-typescript
 * @param x anything
 */
export const assertUnreachable = (x: never): never => {
  throw new Error(`Didn't expect to get to ${x}`)
}
